import React from "react";

import admin_home from "./admin_home.png";
import portal_summary from "./portal_summary.png";

import user_menu from "./user_menu.png";
import report_menu from "./report_menu.png";
import resources_menu from "./resources_menu.png";

const Administration = () => (
  <div>
    <h2>2. Administration</h2>
    <p>
      After you have logged in, to manage a Portal, click the <strong>Portals</strong>&nbsp; link
      from the dark grey
      <strong> administrator</strong>&nbsp;menu towards the top of the page.
    </p>
    <img src={admin_home} alt="Admin Home User" className={"center"} />
    <p>
      A table of portals will be shown, which can be searched. Choose a Portal, you will be
      redirected to the manage portal page.
    </p>
    <img src={portal_summary} alt="Admin Home User" className="center" />
    <p>
      This is the main page for managing a portal, it contains dashboard sections that display
      overviews of the portal's details &amp; usage.
    </p>
    <h4>Charts/Graphs</h4>
    <p>A selection of charts and graphs give show:</p>
    <ul>
      <li>
        <p>Overall user access to the portal.</p>
      </li>
      <li>
        <p>
          Course status. An overview as to the completeness of each course in percentage terms,
          whether complete, incomplete or not attempted.
        </p>
      </li>
      <li>
        <p>Course activity. Lists any users that have started or completed courses.</p>
      </li>
      <li>
        <p>Licenced portals also have a chart to show licence availability.</p>
      </li>
    </ul>
    <p>
      Notice the additional{" "}
      <strong>
        light grey <strong>manage portal</strong>&nbsp;menu
      </strong>
      &nbsp; now appears. This menu is the main point of navigation whilst managing a selected
      portal and contains various functions grouped into 'Users', 'Reports' and 'Configure'
      sections. Each section houses further associated options, clicking on a menu section will
      reveal these options.
    </p>
    <p>"Users" Menu Options:</p>
    <img src={user_menu} alt="User Administration" className="center" />
    <p>"Reports" Menu Options:</p>
    <img src={report_menu} alt="Reporting" className="center" />
    <p>"Configure" Menu Options:</p>
    <img src={resources_menu} alt="Configuration" className="center" />
    <p>The functions are discussed on the pages that follow.</p>
  </div>
);

export default Administration;
